import { render, staticRenderFns } from "./1_BienvenidaNuevos.vue?vue&type=template&id=a5e26e34&scoped=true"
import script from "./1_BienvenidaNuevos.vue?vue&type=script&lang=js"
export * from "./1_BienvenidaNuevos.vue?vue&type=script&lang=js"
import style0 from "./1_BienvenidaNuevos.vue?vue&type=style&index=0&id=a5e26e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e26e34",
  null
  
)

export default component.exports